/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Query Header Status Count Item
 */
export type QueryHeaderStatusCountItem = {
    /**
     * API Response Version
     */
    _ver?: number;
    /**
     * Query Status
     */
    queryStatus?: QueryHeaderStatusCountItem.queryStatus;
    /**
     * Record count for status
     */
    count?: number;
}

export namespace QueryHeaderStatusCountItem {

    /**
     * Query Status
     */
    export enum queryStatus {
        OPEN = 'open',
        CLOSED = 'closed',
        ANSWERED = 'answered',
        HELD = 'held',
        PENDING_CHARGE = 'pending_charge',
        CHARGED = 'charged',
        CREATE = 'create',
        CSRHOLD = 'csrhold',
        CANCELLED = 'cancelled',
        PENDING_SURVEY = 'pending_survey',
        RELEASE = 'release',
    }


}
